let _isGoingBack = false;

export function setGoingBack(value: boolean) {
  _isGoingBack = value;
}

export function consumeGoingBack(): boolean {
  const val = _isGoingBack;
  _isGoingBack = false;
  return val;
}
